import toLower from "lodash/toLower"
import startCase from "lodash/startCase"

export const capitalizeFirstLetterOfEachWord = sentence => {
  return startCase(toLower(sentence))
}

export function interpolate(template, variables) {
  return template.replace(/{{(.*?)}}/g, (_, key) => variables[key.trim()] || "")
}
